import m from 'mithril';
import client from '@shared/utils/client-rest';

class AbacusChart {
    constructor() {
        this.data = null;
        this.showModal = false;
    }

    setData = (data) => (this.data = data);
    setShowModal = (bool) => (this.showModal = bool);

    reset = () => {
        this.data = null;
        this.showModal = false;
    };
}

export default new AbacusChart();
